import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        autoSaveJson: {},
    },
    actions: {

        async getAutoSaveJson({commit}) {
            if ( !localStorage.getItem('auto-save-json') ) {
                return;   
            }
            let json = JSON.parse( localStorage.getItem('auto-save-json') );
            commit('setAutoSaveJson', json );
        },

        async createAutoSaveJson( {commit, dispatch } ) {
            if ( !localStorage.getItem('auto-save-json') ) {
                return;   
            }
            let json = JSON.parse( localStorage.getItem('auto-save-json') );
            if ( !json.id ) {
                let {data} = await axios.post('/client/uploader/product-save', {
                    json: json
                });
                json = JSON.parse(data.product);
                json.id = data.id;
                localStorage.setItem('auto-save-json', JSON.stringify(json) );
            }
        },

        async updateAutoSaveJson( {commit, dispatch } ) {
            let json = JSON.parse( localStorage.getItem('auto-save-json') );
            if ( !json.id ) {
                dispatch('createAutoSaveJson');
                return;
            }

            let {data} = await axios.post('/client/uploader/product-save/' + json.id, {
                json: json
            });
            json = JSON.parse(data.product);
            json.id = data.id;

            if ( json.step == 9 ) {
                localStorage.removeItem('auto-save-json');
            } else {
                localStorage.setItem('auto-save-json', JSON.stringify(json) );
            }

        },

    },

    mutations : {
        setAutoSaveJson(state, data) {
            state.autoSaveJson = data;
        },
    }

}